export function buildPortalWsUrl(
  pathWithQuery: string,
  apiBase: string | undefined,
  location: { protocol: string; host: string },
): string {
  const path = pathWithQuery.startsWith('/') ? pathWithQuery : `/${pathWithQuery}`;
  const base = apiBase === undefined ? 'http://localhost:3000' : apiBase;
  if (base) {
    const u = new URL(base);
    u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${u.origin}${path}`;
  }
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${location.host}${path}`;
}

export function portalWsUrl(pathWithQuery: string): string {
  const env = (import.meta as { env?: { VITE_API_URL?: string } }).env;
  return buildPortalWsUrl(
    pathWithQuery,
    env?.VITE_API_URL,
    window.location,
  );
}
